import {EntityModificationTrace} from '../parameters/EntityModificationTrace';

export class SyncError {
emt: EntityModificationTrace;
level: string;
message: string;
}

